import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { CheckoutDataService, HabaActiveCartService } from '@app/services';
import { MultiCartService, SemanticPathService } from 'haba-core';
import { EmporixSdkService } from 'haba-emporix';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HabaPaymentValidationGuard implements CanActivate {
  constructor(
    public checkoutDataService: CheckoutDataService,
    protected activeCartService: HabaActiveCartService,
    protected semanticPathService: SemanticPathService,
    protected router: Router,
    private http: HttpClient,
    private emporixSdkService: EmporixSdkService,
    private multiCartService: MultiCartService,
    @Inject(PLATFORM_ID) protected platform_id: string
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    if (isPlatformServer(this.platform_id)) {
      return of(true);
    }
    return this.validatePaymentData();
  }

  validatePaymentData(): Observable<boolean> {
    const dateOfBirth = localStorage.getItem('customerDOB');
    const url = this.emporixSdkService.buildSdkUrl('vpd');

    return combineLatest([
      this.activeCartService.getActive(),
      this.activeCartService.isStable(),
      this.activeCartService.getLoading(),
    ]).pipe(
      filter(([, isStable, isLoading]) => isStable && !isLoading),
      take(1),
      map(([cart, ,]) => cart?.code),
      switchMap((cartId) => {
        const params = dateOfBirth ? { cartId, ...JSON.parse(dateOfBirth) } : { cartId };
        return this.http
          .get(url, { withCredentials: true, params, responseType: 'text' })
          .pipe(map(() => cartId));
      }),
      map((cartId) => {
        this.multiCartService.reloadCart(cartId);
        return true;
      })
    );
  }
}
